var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcArrowRightModal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic_arrow_right"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.828 8.38292C13.8362 8.37568 13.8443 8.36813 13.8522 8.36026C13.894 8.31843 13.9269 8.27102 13.9508 8.22042C14.0402 8.03439 14.0078 7.80447 13.8536 7.65024C13.8403 7.63698 13.8265 7.62462 13.8122 7.61316L9.96308 3.76407C9.76782 3.56881 9.45123 3.56881 9.25597 3.76407C9.06071 3.95933 9.06071 4.27591 9.25597 4.47118L12.2953 7.51051L2.59529 7.51051C2.31915 7.51051 2.09529 7.73437 2.09529 8.01051C2.09529 8.28665 2.31915 8.51051 2.59529 8.51051L12.2862 8.51051L9.25736 11.5393C9.0621 11.7346 9.0621 12.0512 9.25736 12.2464C9.45262 12.4417 9.7692 12.4417 9.96447 12.2464L13.828 8.38292Z",
    fill: "black",
    fillOpacity: 0.6
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcArrowRightModal);
export default __webpack_public_path__ + "static/media/ic_arrow_right_modal.c67c21a02a63c429c39aa34358f66b63.svg";
export { ForwardRef as ReactComponent };